var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExternalLink = function SvgExternalLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29982 16.2525C5.90006 16.6523 5.90006 17.3004 6.29982 17.7002C6.69958 18.0999 7.34772 18.0999 7.74748 17.7002L15.9528 9.49489V16.407C15.9528 16.9724 16.4111 17.4307 16.9764 17.4307C17.5418 17.4307 18.0001 16.9724 18.0001 16.407V7.02359C18.0001 6.84373 17.9537 6.67471 17.8722 6.52783C17.8526 6.4925 17.8308 6.45808 17.8067 6.42479C17.7424 6.3358 17.6642 6.25755 17.5752 6.19326C17.4068 6.07162 17.2 5.99994 16.9764 5.99994L7.59297 5.99994C7.02762 5.99994 6.56932 6.45824 6.56932 7.02359C6.56932 7.58894 7.02762 8.04724 7.59297 8.04724L14.5051 8.04724L6.29982 16.2525Z",
    fill: "#6D6A73"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExternalLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "external-link.14d4c460796ff7c58e86e39589c9c63d.svg";